import { useCallStore } from '../store/callStore';
import { clearPendingCallAction, readPendingCallAction, rememberHandledPendingCallAction, shouldIgnoreHandledPendingCallAction, type PendingCallAction } from './callPendingActions';

type CreatePendingActionHandlersParams = {
  answerCall: (withVideo?: boolean) => Promise<void>;
  rejectCall: () => Promise<void> | void;
};

export function createPendingActionHandlers(params: CreatePendingActionHandlersParams) {
  const tryHandleAction = async (action: PendingCallAction) => {
    const incomingCall = useCallStore.getState().incomingCall;
    if (!incomingCall) return;
    if (incomingCall.callSessionId !== action.callSessionId) return;
    if (shouldIgnoreHandledPendingCallAction(action.callSessionId, action.action)) {
      return;
    }
    rememberHandledPendingCallAction(action.callSessionId, action.action);

    if (action.action === 'reject') {
      await params.rejectCall();
      clearPendingCallAction();
      return;
    }

    if (action.action === 'answer') {
      try {
        clearPendingCallAction();
        await params.answerCall(false);
      } catch {
        // answerCall already handles errors
      }
    }
  };

  const bind = () => {
    const onEvent = (event: Event) => {
      const detail = (event as CustomEvent).detail as PendingCallAction | undefined;
      if (!detail) return;
      void tryHandleAction(detail);
    };

    window.addEventListener('videocall:callAction', onEvent);

    const pending = readPendingCallAction();
    if (pending) {
      void tryHandleAction(pending);
    }

    return () => {
      window.removeEventListener('videocall:callAction', onEvent);
    };
  };

  return {
    bind
  };
}
